<template>
  <v-layout
    wrap
    row
  >
    <!-- Project card - left column -->
    <v-flex
      lg3
      md4
      sm6
      xs12
    >
      <v-card>
        <v-img
          src="/img/user-bg.jpg"
          :height="250"
          class="gradient--blue-skies"
        >
          <pa-user-avatar
            class="elevation-2 user-card__avatar"
            :name="user.displayName"
            :image="user.photoURL"
            type="avatar"
            large
          />
        </v-img>

        <span class="headline has-shadow-bg">{{ user.displayName }}</span>

        <v-list
          two-line
          subheader
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ user.jobTitle }}</v-list-item-title>
              <v-list-item-subtitle>Job Title</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-for="customProp in customProperties('user')"
            :key="`custom-prop-${customProp.id}`"
          >
            <v-list-item-content>
              <v-list-item-title>{{ user[customProp.key] || '-' }}</v-list-item-title>
              <v-list-item-subtitle>{{ customProp.name }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-card-actions v-if="isItMe">
          <v-btn
            block
            outlined
            small
            :to="{ name: 'user-profile' }"
          >
            Edit Profile
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-flex
      lg9
      md8
      sm6
      xs12
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          v-for="(project, id) in projects"
          :key="id"
          xl2
          lg3
          md4
          xs6
        >
          <project-card
            :project="project"
            :project-id="id"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import ProjectCard from '@/components/project/ProjectCard'

export default {
  components: {
    ProjectCard
  },
  data () {
    return {
      uid: this.$route.params.id,
      user: {},
      projects: {},
      isItMe: this.$currentUser && this.$currentUser.id === this.$route.params.id
    }
  },
  computed: {
    ...mapGetters([ 'getUserById' ]),
    ...mapGetters('organizations', [ 'customProperties' ])
  },
  mounted () {
    this.user = this.getUserById(this.uid).profile || {}
    this.projects = []
  },
  methods: {
  }
}
</script>

<style lang="scss">
.user-card__avatar {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
